import { IconConfigVariant } from '@repo/sdk/models/components';

import { resolveIconComponent } from '@/features/equipment-browser/utils/resolve-icon-component';
import { cn } from '@/ux-common/lib/utils';

const AnimaticIconVariants: Record<string, string> = {
  [IconConfigVariant.On]: 'fill-primary',
  [IconConfigVariant.Off]: 'fill-ckds-neutral-500',
  [IconConfigVariant.Default]: 'fill-ckds-neutral-500',
} as const;

type AnimaticIconVariant = keyof typeof AnimaticIconVariants;
type AnimaticIconSize = 'sm' | 'md' | 'lg' | 'xl';

const SIZE_CLASSES: Record<AnimaticIconSize, string> = {
  sm: 'glyph-sm',
  md: 'glyph-md',
  lg: 'glyph-lg',
  xl: 'glyph-lg !w-10 !h-10',
};

interface AnimaticIconProps {
  className?: string;
  fallbackIcon?: string;
  icon: string;
  size?: AnimaticIconSize;
  variant?: AnimaticIconVariant;
}

export const AnimaticIcon = ({
  className,
  fallbackIcon,
  icon,
  size = 'md',
  variant = 'default',
}: AnimaticIconProps) => {
  const IconComponent = resolveIconComponent({ fallbackIcon, icon });

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      aria-hidden="true"
      className={cn('glyph', SIZE_CLASSES[size], AnimaticIconVariants[variant], className)}
    />
  );
};
